module.exports = __webpack_public_path__ + "9fb6cc932972abdb9dd43320f8cadef8.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/left_hand/pizza.png
// module id = 2420
// module chunks = 0